export enum JustificationsEnum {
  LEAVE_OF_ABSENCE = "Afastamento temporário",
  VACATION = "Férias",
  SICK_LEAVE = "Licença Médica",
  INSTITUTIONAL = "Motivo institucional",
  ACCESS_REVIEW = "Revisão de acesso",
  OTHER = "Outros",
}
